export default __webpack_public_path__ + "static/media/pag9.46ba6fc4.jpg";